import React, { useState } from 'react'
import { APP_STORE_URL, PLAY_STORE_URL, getPlatform } from '../constants/stores'

function StoreBadges({ className = '', showAll = false }) {
  const [platform] = useState(getPlatform)
  const showIos = showAll || platform !== 'android'
  const showAndroid = showAll || platform !== 'ios'

  return (
    <div className={`store-badges ${className}`}>
      {showIos && (
        <a className="store-badge" href={APP_STORE_URL} rel="noopener" aria-label="Download Gym Journey on the App Store">
          <img src="/assets/app_store_logo.webp" alt="Download on the App Store" width="162" height="48" />
        </a>
      )}
      {showAndroid && (
        <a className="store-badge store-badge--play" href={PLAY_STORE_URL} rel="noopener" aria-label="Get Gym Journey on Google Play">
          <img src="/assets/google_play_logo.webp" alt="Get it on Google Play" width="181" height="70" />
        </a>
      )}
    </div>
  )
}

export default StoreBadges
